// feat_347 — Tab "Integraciones y API" de /Settings.
//
// 🔴 REGLA #1 DE ESTA PANTALLA: los 8 TabPanel quedan SIEMPRE MONTADOS (el shell
// los oculta con `hidden`, nunca los desmonta). 21 campos de texto guardan con
// `onBlur`; si al cambiar de tab React desmontara el input, el onBlur NO dispara
// y el usuario pierde lo tipeado sin ningún aviso. NO convertir esto en render
// condicional ni en lazy.
//
// Todo el estado vive en el padre (`Settings/index.js`) y llega por `ctx`.
// El JSX es un MOVIMIENTO VERBATIM de index.js — Fase 1 no cambia ni un pixel.

import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { toast } from "react-toastify";

import { i18n } from "../../../translate/i18n.js";
import DevSection from "../components/DevSection";

const TabIntegraciones = ({ ctx }) => {
	const {
		classes,
		getSettingValue,
		showApiToken, setShowApiToken,
		visibleWebhookFields,
		getFieldValue,
		setFieldValue,
		handleKeyDown,
		handleSaveWebhookSettings,
	} = ctx;

	return (
		<>
			{/* API Token */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.tokenAPI")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<Typography variant="caption" color="textSecondary" style={{ marginBottom: 8 }}>
					{i18n.t("settingsExtra.usarTokenDesc")}
				</Typography>
				<TextField
					id="api-token-setting"
					label={i18n.t("settingsExtra.tokenAPI")}
					margin="dense"
					variant="outlined"
					fullWidth
					type={showApiToken ? "text" : "password"}
					value={getSettingValue("userApiToken")}
					InputProps={{
						readOnly: true,
						style: { fontFamily: "monospace", fontSize: 13 },
						endAdornment: (
							<InputAdornment position="end">
								<Tooltip title={showApiToken ? i18n.t("settingsExtra.ocultarToken") : i18n.t("settingsExtra.mostrarToken")}>
									<IconButton size="small" onClick={() => setShowApiToken(v => !v)}>
										{showApiToken ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
									</IconButton>
								</Tooltip>
								<Tooltip title={i18n.t("settingsExtra.copiarToken")}>
									<IconButton
										size="small"
										onClick={() => {
											const val = getSettingValue("userApiToken");
											if (val) navigator.clipboard.writeText(val).then(() => toast.success(i18n.t("settingsExtra.tokenCopiado"))).catch(() => {});
										}}
									>
										<FileCopyIcon fontSize="small" />
									</IconButton>
								</Tooltip>
							</InputAdornment>
						),
					}}
				/>
			</Paper>

			{/* Webhook / AI integration section */}
			{visibleWebhookFields.length > 0 && (
				<>
					<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
						{i18n.t("settingsExtra.integracionIA")}
					</Typography>

					{visibleWebhookFields.map(({ key, label, type, inputProps, multiline, rows, defaultValue }) => (
						<Paper key={key} className={classes.paper}>
							<TextField
								id={`${key}-setting`}
								label={label}
								margin="dense"
								variant="outlined"
								fullWidth
								type={type || "text"}
								multiline={!!multiline}
								rows={rows}
								value={getFieldValue(key) || (defaultValue || "")}
								onChange={e => setFieldValue(key, e.target.value)}
								onKeyDown={!multiline ? handleKeyDown : undefined}
								inputProps={inputProps}
							/>
						</Paper>
					))}

					<Button
						variant="contained"
						color="primary"
						className={classes.saveButton}
						onClick={handleSaveWebhookSettings}
						fullWidth
					>
						{i18n.t("settingsExtra.guardarConfig")}
					</Button>
				</>
			)}

			{/* Developers section */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				Desarrolladores
			</Typography>
			<DevSection apiToken={getSettingValue("userApiToken")} classes={classes} />
		</>
	);
};

export default TabIntegraciones;
